const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  name: 'c=>c.Name',
}

export const mapSortRoleParam = (key: string) => mapping[key]
